import { Label } from "@/components/ui/label";
import type { ReactNode } from "react";

export function PartyFieldLabel({ children, required }: { children: ReactNode; required?: boolean }) {
  return (
    <Label className="text-xs font-bold text-foreground">
      {children}
      {required ? <span className="text-destructive"> *</span> : null}
    </Label>
  );
}

export function PartyFormSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="rounded-xl border border-border/60 bg-muted/10 p-4 space-y-3">
      <p className="text-xs font-bold text-foreground border-b border-border/40 pb-2">{title}</p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
    </div>
  );
}
